import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de megáfono para BordOneToneIcon
 */
const BordMegaPhoneIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, fill } = props;
  return (
    <svg viewBox="0 0 14 14" fill="none">
      <path
        d="M5.07305 11.5632C6.51838 11.5632 7.69005 10.409 7.69005 8.98523C7.69005 7.56144 6.51838 6.40723 5.07305 6.40723C3.62773 6.40723 2.45605 7.56144 2.45605 8.98523C2.45605 10.409 3.62773 11.5632 5.07305 11.5632Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
      />
      <path
        d="M11.0321 10.1324L2.2181 7.39625C0.342014 6.81386 0.342014 4.15846 2.2181 3.57607L11.0321 0.839996C11.2241 0.780394 11.4294 0.734834 11.6203 0.798081C13.7132 1.49172 13.7132 9.4806 11.6203 10.1743C11.4294 10.2375 11.2241 10.192 11.0321 10.1324Z"
        fill={fill || bordColorTheme.navyBlue[400]}
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default BordMegaPhoneIcon;
